
<div style="display:block; color:red; font-weight: bold;">
    WARNING: Please ensure all numbers on social security cards and driver licenses are hidden / protected
    before uploading the document(s).
</div>

<div style="color: blue;padding-top:10px;">
    <span *ngIf="isAdd">Click the 'Browse' button and choose a jpg file</span>
    <span *ngIf="!isAdd">Change the category of the document</span>

</div>
<div class="dwform">

 	<div class="dwform-cell-nopadding" style="min-width: 500px;">
        <div class="dwform-row-double-gap"></div>
        <div class="dwform-row">
            <label class="label-field">Document:</label>
            <span class="form-required">*</span>
            <input class="input-field-longest" id="documentName" disabled="true"
                   style="text-transform: capitalize;;width: 280px;"
                   [(ngModel)]="valDocumentName"
                   placeholder="<Click Browse>"
                   type="text">
            <input #fileInput hidden="true" type="file"
                   onclick="this.value=null" (change)="fileInputChange($event); this.strErr = '';"
                   accept="image/*,application/pdf"/>
            <button *ngIf="isAdd" (click)="fileInput.click()" mat-button
                    id="browseId"
                    matTooltip="Look for an image file to upload"
                    matTooltipPosition="below"
                    class="command-button" style="width: 100px">
                <mat-icon>search</mat-icon>Browse</button>

         </div>
		 <div class="dwform-row-gap"></div>
		  <div class="dwform-row">

              <label class="label-field">Category:</label>
              <span class="form-required">*</span>
              <dw-dropdown [style]="{'font-size': '9pt', 'width': '280px'}"
                             [dataSource]="docCategoryList"
                             [selectedItem]="docCategoryId"
                             (itemSelected)="docCategoryId = $event"
                             [controlWidth]="'280px'">

              </dw-dropdown>
<!--               <input class="input-field-longest" id="documentType" -->
<!--                      style="text-transform: capitalize;width: 280px;" -->
<!--                      matTooltip="eg: 'Drivers license' or 'Utilities Bill'" -->
<!--                      matTooltipPosition="right" -->
<!--                      [(ngModel)]="valDescription" -->
<!--                      placeholder="<Describe Document>" -->
<!--                      type="text"> -->


         </div>
		 <div class="dwform-row-gap"></div>
	</div>
 </div>
  <!----------------------->
  <!-- ERROR LINE --------->
  <!----------------------->
  <div class="error-line" [hidden]='!strErr.length'
       style="text-align:left;margin-bottom: 13px;">{{strErr}}</div>
  <!----------------------->
  <!-- SAVE STRIP        -->
  <!----------------------->
  <div class="save-close-strip" style="bottom: 10px;">

      <button mat-button class="command-button" [disabled]="!submitEnabled"
              (click)="submitRecord()" matTooltip="Save the record"
              mat-button>
          <mat-icon>check_circle_outline</mat-icon>
          Submit
      </button>
      <button mat-button class="command-button" 
              (click)="cancelSubmitRecord()" matTooltip="Close window" mat-button>
          <mat-icon>highlight_off</mat-icon>
          Cancel
      </button>
  </div>
